import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoshirdicab() {



  const cardData =
  {
    keyword: 'Mumbai to Shirdi Cab  ',
    heading: 'Shambhu Cabs: Mumbai to Shirdi Cab ',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Shirdi Cab services, providing safe, comfortable, and hassle-free travel for devotees, families, friends, and corporate travelers visiting the holy town of Shirdi. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and convenient journey from Mumbai to Shirdi with spacious seating and well-maintained vehicles. With flexible one-way and round-trip options, experienced chauffeurs, and 24/7 booking support, Shambhu Cabs makes your pilgrimage or trip stress-free and enjoyable. From South Mumbai to Thane, Andheri to Vashi, Shambhu Cabs provides doorstep pickup and trusted Mumbai to Shirdi cab services for all travelers seeking comfort, safety, and reliability.',

    top: 'Top Places to Visit in Shirdi with Shambhu Cabs',

 "topPlaces": [
  {
    "title": "Shri Sai Baba Samadhi Mandir",
    "description": "The core spiritual heart of Shirdi — Samadhi Mandir houses the mausoleum and a white‑marble idol of Sai Baba of Shirdi. Devotees come from all over to offer prayers and participate in daily aartis and bhajans, making it the most visited and revered place in Shirdi."
  },
  {
    "title": "Dwarkamai",
    "description": "Dwarkamai is the mosque‑temple where Sai Baba lived for many decades. The sacred fire (dhuni) he lit still burns there today, and the place reflects his teachings of unity, faith and humility. Visiting Dwarkamai gives a deep sense of the saint’s life and spiritual legacy."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi was the place where Sai Baba spent alternate nights in his later years. The site now serves as a shrine and museum, housing items used by him — including his wooden bed, sandals and robes — and preserves the atmosphere of quiet devotion. It’s a significant stop for devotees tracing Baba’s daily life."
  },
  {
    "title": "Gurusthan",
    "description": "Gurusthan marks the spot where Sai Baba was first seen meditating under a neem tree as a young boy. Today a small shrine stands here, with the original neem tree still venerated by devotees. The site is considered sacred and reflects the early origins of Baba’s spiritual journey."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a tranquil garden near the temple area — believed to be cared for by Sai Baba himself. The garden features a sacred lamp (Nanda Deep) that continues to burn, and the calm greenery offers devotees a peaceful retreat within Shirdi’s spiritual atmosphere."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is an open‑air heritage‑museum and picnic spot that recreates old Shirdi village life and key events from Sai Baba’s times using dioramas and displays. It’s a nice mix of spirituality, history and light‑hearted family‑friendly exploring — especially for those travelling with kids or wanting a broader sense of Shirdi’s past."
  },
  {
    "title": "Sai Teerth Devotional Theme Park",
    "description": "Sai Teerth is a devotional theme park located near Shirdi that offers a mix of entertainment and spirituality — with attractions like miniature trains, shows about scenes from Indian mythology, and displays related to Sai Baba’s life. Good for families or travellers wanting a relaxed, fun‑filled break along with spiritual visits."
  },
  {
    "title": "Wet ’n’ Joy Water Park",
    "description": "For those looking to add a bit of leisure and fun to their spiritual visit, Wet ’n’ Joy Water Park offers water‑based recreation near Shirdi. It’s a popular spot for families and groups — giving a balanced mix of pilgrimage, relaxation, and enjoyment."
  }
],


 "services": [
  {
    "name": "Mumbai to Shirdi Cab",
    "description": "Mumbai to Shirdi Cab offers a comfortable and reliable outstation travel solution for pilgrims and tourists visiting the sacred town of Shirdi. With professional chauffeurs, well-maintained vehicles, timely pickups, and complete route knowledge, this service ensures a smooth journey along the Mumbai–Shirdi highway. Ideal for family travel, religious visits, and group trips, it provides doorstep service, flexible schedules, and full travel assistance to make your long-distance journey peaceful and stress-free."
  },
  {
    "name": "Mumbai to Shirdi Taxi",
    "description": "Mumbai to Shirdi Taxi provides safe and convenient long-distance transportation for travelers heading to Shirdi Sai Baba Temple. Featuring comfortable seating, courteous drivers trained for highway driving, and flexible booking slots, this service ensures a pleasant travel experience. Whether you need a quick pickup, early morning departure, or late-night travel, this taxi option delivers reliability, punctuality, and a seamless journey from Mumbai to Shirdi."
  },
  {
    "name": "Mumbai to Shirdi Taxi Fare",
    "description": "Mumbai to Shirdi Taxi Fare offers transparent pricing for various vehicle categories including sedans, SUVs, tempo travelers, and luxury cars. Travelers get complete clarity on tolls, driver allowances, and distance-based charges. This service is designed to help customers choose the most cost-effective ride option for their travel needs, ensuring affordability without compromising on comfort and safety during the long drive to Shirdi."
  },
  {
    "name": "Mumbai to Shirdi Car Rental",
    "description": "Mumbai to Shirdi Car Rental provides full-day and one-way rental options with experienced drivers, clean vehicles, and customizable travel plans. Customers can select from a wide range of cars, including sedans, hatchbacks, and SUVs, depending on budget and comfort preferences. This service is ideal for pilgrims, families, and tourists seeking a personalized, private travel experience with complete flexibility over travel timings."
  },
  {
    "name": "Mumbai to Shirdi Taxi Service",
    "description": "Mumbai to Shirdi Taxi Service delivers dependable outstation transportation with 24/7 availability, instant booking support, and smooth, punctual travel. Drivers are experienced in long-route driving and ensure a safe journey through highways and ghats. With spacious cars, AC comfort, and a focus on customer satisfaction, this taxi service guarantees a relaxing journey for religious visits and weekend trips to Shirdi."
  },
  {
    "name": "Mumbai to Shirdi Cabs Round Trip",
    "description": "Mumbai to Shirdi Cabs Round Trip offers a flexible two-way travel solution for travelers planning to return the same day or stay overnight in Shirdi. The service includes dedicated chauffeurs, waiting time, customized sightseeing stops, and clean, comfortable vehicles. Round-trip packages help passengers save money and enjoy a stress-free return journey at their preferred timing."
  },
  {
    "name": "Mumbai to Shirdi Taxi Innova Fare",
    "description": "Mumbai to Shirdi Taxi Innova Fare provides detailed pricing for booking spacious Toyota Innova and Innova Crysta vehicles for the Mumbai–Shirdi route. Ideal for families and group travel, these SUVs offer premium comfort, strong stability, extra luggage space, and a smooth journey over long distances. Fare structures are transparent, competitive, and designed to offer maximum value for group travelers."
  },
  {
    "name": "Mumbai to Shirdi Cab Service",
    "description": "Mumbai to Shirdi Cab Service provides consistent, high-quality transportation for pilgrims and tourists. The service includes clean cabs, friendly drivers, highway safety assurance, and on-time pickups from any location in Mumbai. Whether traveling alone or in a group, passengers enjoy a comfortable, uninterrupted journey with complete customer support throughout the trip."
  },
  {
    "name": "Mumbai to Shirdi Taxi Cost",
    "description": "Mumbai to Shirdi Taxi Cost gives travelers a transparent understanding of all charges, including base fare, fuel costs, tolls, and driver allowances. The service ensures no hidden charges and offers multiple vehicle categories to match specific budgets. Customers can easily compare prices and choose the best option for their Shirdi pilgrimage."
  },
  {
    "name": "Mumbai Airport to Shirdi Taxi",
    "description": "Mumbai Airport to Shirdi Taxi provides direct, hassle-free transfers from Chhatrapati Shivaji Maharaj International Airport to Shirdi. It is ideal for outstation visitors and NRIs arriving in Mumbai who need a smooth, comfortable journey to the Shirdi temple. Drivers track flight timings and offer punctual pickups, ensuring a seamless and stress-free transfer experience."
  },
  {
    "name": "Mumbai Airport to Shirdi Taxi Fare",
    "description": "Mumbai Airport to Shirdi Taxi Fare outlines clear pricing for travelers seeking direct airport-to-Shirdi transportation. The fare includes reliable pickup service, professional airport chauffeurs, luggage assistance, and a comfortable long-distance ride. Customers can choose from sedans, SUVs, and premium cars based on their comfort and budget preferences."
  },
  {
    "name": "Mumbai to Shirdi Taxi Price",
    "description": "Mumbai to Shirdi Taxi Price helps travelers estimate the exact cost of booking a cab from Mumbai to Shirdi. The pricing is transparent and includes all expenses related to distance, fuel, tolls, and driver charges. Suitable for planning religious trips, the service ensures affordability and clear communication regarding fare details."
  },
  {
    "name": "Mumbai to Shirdi Taxi One Way",
    "description": "Mumbai to Shirdi Taxi One Way is designed for passengers who need a single-drop service at Shirdi without paying return charges. This makes it an economical choice for extended stays, hotel check-ins, or one-way trips planned for religious visits. The service includes punctual drivers, a comfortable ride, and flexible scheduling."
  },
  {
    "name": "Mumbai to Shirdi by Car Fare",
    "description": "Mumbai to Shirdi by Car Fare provides complete fare breakdowns for travelers choosing private car travel. Customers get detailed pricing for sedans, SUVs, and luxury cars, ensuring transparency and helping them pick the right travel option. This service is ideal for planning personalized and family-friendly trips to Shirdi."
  },
  {
    "name": "Mumbai to Shirdi Cab Fare",
    "description": "Mumbai to Shirdi Cab Fare ensures passengers receive honest, upfront information about all travel costs. The fare includes AC cab services, tolls, fuel, and driver allowances. This helps travelers plan their journey more efficiently with no hidden surprises, ensuring a pleasant long-distance travel experience."
  },
  {
    "name": "Mumbai to Shirdi by Car",
    "description": "Mumbai to Shirdi by Car is a comfortable and private travel solution for families and groups seeking a personalized journey. With experienced drivers, safe cars, and flexible travel timing, passengers enjoy a peaceful ride to Shirdi. This option offers the convenience of stops, refreshments, and complete travel flexibility."
  },
  {
    "name": "Mumbai to Shirdi Cab Price",
    "description": "Mumbai to Shirdi Cab Price provides clear and competitive pricing for one-way and round-trip cab bookings. Passengers can select from various vehicle options and enjoy complete transparency on charges. This service is ideal for budget-conscious travelers planning a pilgrimage to Shirdi."
  },
  {
    "name": "Mumbai Airport to Shirdi by Car",
    "description": "Mumbai Airport to Shirdi by Car gives travelers a personalized and relaxed travel option directly from the airport to Shirdi. With real-time flight tracking, skilled drivers, and smooth long-distance travel arrangements, this service is perfect for those who prefer private and comfortable transportation after a long flight."
  },
  {
    "name": "Mumbai Shirdi Car Rental",
    "description": "Mumbai Shirdi Car Rental offers a wide selection of rental cars for long-distance travel with professional drivers. Customers can book sedans, SUVs, and premium cars based on comfort requirements. The service provides flexible rental durations, door-to-door service, and complete travel assistance."
  },
  {
    "name": "Mumbai to Shirdi Cab Booking",
    "description": "Mumbai to Shirdi Cab Booking provides a quick, convenient, and fully online booking process. Travelers can check vehicle availability, compare prices, choose cab types, and confirm bookings instantly. Ideal for families and individuals planning a pilgrimage, this service ensures smooth and flexible booking."
  },
  {
    "name": "Mumbai to Shirdi Cab Booking Online",
    "description": "Mumbai to Shirdi Cab Booking Online enables travelers to reserve their cab digitally with real-time vehicle options, instant fare quotes, and secure payment methods. Customers can choose from multiple car types and enjoy a hassle-free online reservation experience for their Shirdi trip."
  },
  {
    "name": "Mumbai to Shirdi Cab Booking Price",
    "description": "Mumbai to Shirdi Cab Booking Price provides a clear cost structure for online cab reservations. Travelers can compare different vehicle categories and select the most suitable option for their budget. Transparent pricing ensures no hidden charges and complete clarity before travel."
  },
  {
    "name": "Mumbai to Shirdi Car Booking",
    "description": "Mumbai to Shirdi Car Booking offers personalized travel arrangements with flexible scheduling and complete route convenience. Passengers can choose from standard to luxury cars and enjoy a smooth and relaxed long-distance journey with experienced drivers."
  },
  {
    "name": "Mumbai to Shirdi Car Hire",
    "description": "Mumbai to Shirdi Car Hire provides long-distance car rental options with trained drivers for comfortable outstation travel. Travelers benefit from clean vehicles, safe driving, punctuality, and customized travel planning for the Shirdi pilgrimage."
  },
  {
    "name": "Mumbai to Shirdi Car Package",
    "description": "Mumbai to Shirdi Car Package includes all-inclusive pricing for pilgrims wanting a round-trip or full-day travel plan. Packages cover tolls, driver allowances, waiting charges, and sightseeing options, making travel simpler and more convenient."
  },
  {
    "name": "Mumbai to Shirdi Car Rental Price",
    "description": "Mumbai to Shirdi Car Rental Price provides detailed rental rates for various vehicles including sedans, SUVs, and premium cars. With flexible rental durations and transparent billing, it helps travelers choose the most cost-effective option for their journey."
  },
  {
    "name": "Mumbai to Shirdi Innova Fare",
    "description": "Mumbai to Shirdi Innova Fare offers clear pricing details for booking Toyota Innova cabs for the long-distance trip. Ideal for groups and families, Innovas provide superior comfort, excellent performance, and a spacious ride for long journeys."
  },
  {
    "name": "Mumbai to Shirdi Return Cab Fare",
    "description": "Mumbai to Shirdi Return Cab Fare outlines cost details for round-trip cab travel. This service ensures lower pricing compared to separate bookings and offers flexible return schedules, making it perfect for pilgrims and weekend travelers."
  },
  {
    "name": "Mumbai to Shirdi Taxi Charges",
    "description": "Mumbai to Shirdi Taxi Charges provides complete transparency on all costs associated with the journey. Travelers get clear details on per-kilometer rates, tolls, fuel expenses, and driver charges to make informed travel decisions."
  },
  {
    "name": "Mumbai to Shirdi Round Trip Taxi Fare",
    "description": "Mumbai to Shirdi Round Trip Taxi Fare gives travelers an economical price structure for two-way journeys. It includes waiting time, return allowances, and complete fare breakdowns to ensure clarity before travel planning."
  },
  {
    "name": "Mumbai to Shirdi Taxi Travel Time",
    "description": "Mumbai to Shirdi Taxi Travel Time provides estimated journey durations based on traffic, route selection, and halts. Typically ranging from 5 to 7 hours, the service ensures comfortable travel with experienced drivers who manage long trips efficiently."
  },
  {
    "name": "Taxi from Mumbai Airport to Shirdi",
    "description": "Taxi from Mumbai Airport to Shirdi offers convenient airport pickup services for travelers arriving from domestic and international flights. The service provides clean cabs, courteous drivers, and smooth long-distance travel directly to Shirdi without delays."
  },
  {
    "name": "Taxi Service from Mumbai to Shirdi",
    "description": "Taxi Service from Mumbai to Shirdi ensures reliable, safe, and comfortable outstation travel with professional chauffeurs and well-maintained vehicles. Perfect for religious visits, family travel, and weekend getaways, this service guarantees a smooth travel experience."
  }
],

"tableData": [
  ["Mumbai to Shirdi Cab", "Mumbai to Shirdi Taxi"],
  ["Mumbai to Shirdi Taxi Fare", "Mumbai to Shirdi Car Rental"],
  ["Mumbai to Shirdi Taxi Service", "Mumbai to Shirdi Cabs Round Trip"],
  ["Mumbai to Shirdi Taxi Innova Fare", "Mumbai to Shirdi Cab Service"],
  ["Mumbai to Shirdi Taxi Cost", "Mumbai Airport to Shirdi Taxi"],
  ["Mumbai Airport to Shirdi Taxi Fare", "Mumbai to Shirdi Taxi Price"],
  ["Mumbai to Shirdi Taxi One Way", "Mumbai to Shirdi by Car Fare"],
  ["Mumbai to Shirdi Cab Fare", "Mumbai to Shirdi by Car"],
  ["Mumbai to Shirdi Cab Price", "Mumbai Airport to Shirdi by Car"],
  ["Mumbai Shirdi Car Rental", "Mumbai to Shirdi Cab Booking"],
  ["Mumbai to Shirdi Cab Booking Online", "Mumbai to Shirdi Cab Booking Price"],
  ["Mumbai to Shirdi Car Booking", "Mumbai to Shirdi Car Hire"],
  ["Mumbai to Shirdi Car Package", "Mumbai to Shirdi Car Rental Price"],
  ["Mumbai to Shirdi Innova Fare", "Mumbai to Shirdi Return Cab Fare"],
  ["Mumbai to Shirdi Taxi Charges", "Mumbai to Shirdi Round Trip Taxi Fare"],
  ["Mumbai to Shirdi Taxi Travel Time", "Taxi from Mumbai Airport to Shirdi"],
  ["Taxi Service from Mumbai to Shirdi", "—"]
],




"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Shirdi Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers dependable Mumbai to Shirdi cab services, perfect for pilgrimage trips, family travel, and comfortable long-distance journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, spacious, and air-conditioned cabs that are regularly maintained to ensure a safe and relaxing journey to Shirdi."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Outstation and Pilgrimage Routes",
    "WhyChoosedescription": "Our professional drivers are well-versed with the Mumbai to Shirdi route, ensuring a smooth, safe, and timely travel experience."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy upfront and honest pricing for your Mumbai to Shirdi cab ride—fuel, tolls, and driver allowances included with no surprises."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available 24/7 to help with bookings, travel-related queries, and assistance throughout your journey."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Pilgrimage Travel",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized rental plans tailored to your Mumbai to Shirdi travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "Each cab is thoroughly cleaned and sanitized before every trip to ensure a hygienic and comfortable travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and dependable service, making your Mumbai to Shirdi journey smooth, hassle-free, and comfortable."
  }
]















  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to Shirdi cab services?',
    answer: 'Yes, Shambhu Cabs provides reliable and comfortable Mumbai to Shirdi cab services with professional drivers for a smooth pilgrimage journey.',
  },
  {
    question: 'How can I book a Mumbai to Shirdi cab with Shambhu Cabs?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Shirdi cab bookings?',
    answer: 'Shambhu Cabs offers well-maintained sedans, SUVs, and luxury cars suitable for a safe and convenient trip to Shirdi.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to Shirdi route?',
    answer: 'Yes, our drivers are licensed, experienced, and familiar with the Mumbai to Shirdi route to ensure a safe and stress-free journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai to Shirdi cab?',
    answer: 'Absolutely. You can choose your preferred pickup point in Mumbai and drop-off location anywhere in Shirdi.',
  },
  {
    question: 'Is the Mumbai to Shirdi cab service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock cab booking services for Mumbai to Shirdi travel.',
  },
  {
    question: 'Are safety and hygiene measures followed for Mumbai to Shirdi cab bookings?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict safety and hygiene protocols for passenger well-being.',
  },
  {
    question: 'What payment options are available for Mumbai to Shirdi cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate payments.',
  },
  {
    question: 'Is customer support available during the Mumbai to Shirdi journey?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your travel.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Harish Desai',
    feedback: 'Our Mumbai to Shirdi trip with Shambhu Cabs was peaceful and well-organized. Highly recommended for pilgrimage travel!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Kavita More',
    feedback: 'Very reliable Mumbai to Shirdi cab service. The driver was polite and the journey was smooth. Great experience with Shambhu Cabs!',
    rating: 5,
  },
];









































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Shirdi Cab",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-shirdi-cab.jpg",
  "description": "Book Mumbai to Shirdi cab services with Shambhu Cabs for a safe, comfortable, and affordable journey. Choose from sedans, SUVs, Innova, and premium vehicles for one-way or round-trip travel. Enjoy clean cars, reliable drivers, and transparent Mumbai to Shirdi taxi fares.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3200",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-shirdi-cab"
  }
};







  return (
    <div>
<Helmet>
  <title>Mumbai to Shirdi Cab | Affordable Taxi Service | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book affordable Mumbai to Shirdi cab services with Shambhu Cabs. Clean cars, expert drivers, and transparent taxi fares for one-way or round-trip travel. Mumbai Airport to Shirdi taxi also available."
  />

  <meta
    name="keywords"
    content="Mumbai to shirdi cab, Mumbai to shirdi taxi, Mumbai to shirdi taxi fare, mumbai to shirdi car rental, mumbai to shirdi taxi service, mumbai to shirdi cabs round trip, mumbai to shirdi taxi innova fare, mumbai to shirdi cab service, mumbai to shirdi taxi cost, mumbai airport to shirdi taxi, mumbai airport to shirdi taxi fare, mumbai to shirdi taxi price, Mumbai to shirdi taxi one way, mumbai to shirdi by car fare, mumbai to shirdi cab fare, Mumbai to shirdi by car, Mumbai to shirdi cab price, mumbai airport to shirdi by car, Mumbai shirdi car rental, Mumbai to shirdi cab booking, Mumbai to shirdi cab booking online, Mumbai to shirdi cab booking price, mumbai to shirdi car booking, mumbai to shirdi car hire, mumbai to shirdi car package, Mumbai to shirdi car rental price, mumbai to shirdi innova fare, mumbai to shirdi return cab fare, Mumbai to shirdi taxi charges, Mumbai to shirdi round trip taxi fare, Mumbai to shirdi taxi travel time, taxi from mumbai airport to shirdi, Taxi service from mumbai to shirdi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/2.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoshirdicab;